import { takeEvery, put, call, select } from 'redux-saga/effects'

import api from 'api'

import {
  getEquipmentFilterData,
  setEquipmentFilterData,
  setIsFetchingFilterData,
  setEquipmentSelectedDateRange,
  getEquipmentSelectedDateRangeSelector,
  getEquipmentFacilityIdSelector,
  clearSelectedFilterData,
  setConsamptionData,
  setIsFetchingConsaption,
  getEquipmentConsamptionData,
  setSelectedDevice,
  getSelectedDeviceSelector,
  setSelectedPanel,
  getSelectedPanelSelector,
  setLastUpdate,
} from 'redux/reducers/equipments'
import { showAlert } from 'redux/reducers/notification'
import {setIsRedirect} from '../reducers/isRedirectForPages'

const filterIdPrefix = {
  panels: 'all_panels',
  device: 'all_devices',
}

function* getEquipmentFilterDataSagaWorker() {
  try {
    yield put(setIsFetchingFilterData(true))
    const facilityId = yield select(getEquipmentFacilityIdSelector)
    const { value: params } = yield select(
      getEquipmentSelectedDateRangeSelector
    )
    const { data } = yield call(
      [api.facility, 'getEquipmentFilterData'],
      facilityId,
      params
    )
    yield put(setEquipmentFilterData(data.body))
    if(data.body === 'Invalid request body, path or querystring params') {
      throw new Error()
    }
  } catch (error) {
    /// sad
    yield put(clearSelectedFilterData())
    yield put(
      showAlert({
        message: 'Retrieving data failed - try again later',
        severity: 'error',
        timeoutHide: 0,
      })
    )
    yield put(setIsRedirect(true))
  } finally {
    yield put(setIsFetchingFilterData(false))
  }
}

function* getEquipmentConsamptoinDataSagaWorker({ type }) {
  try {
    yield put(setIsFetchingConsaption(true))
    const facilityId = yield select(getEquipmentFacilityIdSelector)
    const { id: deviceSelectedValue } = yield select(getSelectedDeviceSelector)
    const { id: panelSelectedValue } = yield select(getSelectedPanelSelector)

    const { value: dateSelectedValue } = yield select(
      getEquipmentSelectedDateRangeSelector
    )

    let params = {}

    if (dateSelectedValue) params = { ...dateSelectedValue }

    if (
      panelSelectedValue &&
      !panelSelectedValue?.includes(filterIdPrefix.panels)
    ) {
      params = { ...params, panel_id: panelSelectedValue }
    }

    if (
      deviceSelectedValue &&
      !deviceSelectedValue?.includes(filterIdPrefix.device) &&
      type !== setSelectedPanel.type
    )
      params = { ...params, device_id: deviceSelectedValue }

    const { data, headers } = yield call(
      [api.facility, 'getEquipmentConsumptionData'],
      facilityId,
      params
    )

    yield put(setConsamptionData(data?.body))
    yield put(setLastUpdate(headers?.date || null))
  } catch (error) {
    yield put(
      showAlert({
        message: 'Retrieving data failed - try again later',
        severity: 'error',
        timeoutHide: 0,
      })
    )
  } finally {
    yield put(setIsFetchingConsaption(false))
  }
}

export default function* equipmentSagaWatcher() {
  yield takeEvery(
    [getEquipmentFilterData.type, setEquipmentSelectedDateRange.type],
    getEquipmentFilterDataSagaWorker
  )
  yield takeEvery(
    [
      getEquipmentConsamptionData.type,
      setEquipmentSelectedDateRange.type,
      setSelectedDevice.type,
      setSelectedPanel.type,
    ],
    getEquipmentConsamptoinDataSagaWorker
  )
}
